import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const settingsManifestRoutes: ManifestRouteDefinition[] = [
  {
    key: 'settings',
    path: '/settings',
    apiCalls: [],
    subFeatures: [
      {
        key: 'settings',
        label: 'Settings',
        apiCalls: [],
      },
    ],

    lazyComponent: () =>
      import('@/features/settings/pages/Settings/Settings').then((m) => ({
        default: m.default,
      })),
  },
]
